import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=6da38bec&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da38bec')) {
      api.createRecord('6da38bec', component.options)
    } else {
      api.reload('6da38bec', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=6da38bec&", function () {
      api.rerender('6da38bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2T2IinIkhZz1y/JS/comp/offers.vue"
export default component.exports